import React, { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import BusinessAccountSection from '../ads/business-account-section';
import IndividualOrdererCard from '../ads/individual-orderer-card';
import BrandCampaignSection from './brand-campaign-section';
import { AdAccount, getMyAdAccounts } from '../../api/ads/ad-account.api';
import { getUserBalanceBuckets } from '../../api/payment/store.api';
import { splitOrdererAccounts } from '../../utils/individual-order';

// Vai "Tôi thuê creator" của trang Hợp tác quảng cáo. Trước đây khu này nằm trong trang Quảng cáo (Cab Ads tính
// theo lượt bấm) nên sếp không tìm ra chỗ tạo chiến dịch (14/10): nay gom về đây, trang Quảng cáo chỉ còn Cab Ads.
const BrandOrdererHub: React.FC = () => {
  const [topUpCa, setTopUpCa] = useState<number | null>(null);
  const [individualAccount, setIndividualAccount] = useState<AdAccount | null>(null);
  const [bizAccounts, setBizAccounts] = useState<AdAccount[]>([]);
  const [showIndividualCard, setShowIndividualCard] = useState(false);
  const [accountsLoaded, setAccountsLoaded] = useState(false);

  useEffect(() => {
    getUserBalanceBuckets()
      .then((b) => setTopUpCa(b.topUpBalance))
      .catch(() => undefined);
    getMyAdAccounts()
      .then((accs) => {
        const { business, individual } = splitOrdererAccounts(accs);
        setBizAccounts(business);
        setIndividualAccount(individual);
        setShowIndividualCard(accs.length === 0 || !!individual);
      })
      .catch(() => undefined)
      .finally(() => setAccountsLoaded(true));
  }, []);

  const hasOrdererAccount = bizAccounts.length > 0 || !!individualAccount;

  return (
    <div className="space-y-4">
      {accountsLoaded && !hasOrdererAccount && (
        <div className="rounded-xl border border-[#0057FF]/30 bg-[#f5f8ff] p-4 space-y-2 dark:border-slate-600 dark:bg-slate-800">
          <h2 className="flex items-center gap-2 font-semibold ui-text">
            <Users size={18} className="text-[#0057FF]" /> Mở tài khoản đặt đơn để tạo chiến dịch
          </h2>
          <p className="text-sm ui-muted">
            Bạn tạo chiến dịch để mời creator đăng bài, giao brief cho creator làm nội dung, hoặc nhận đề xuất từ creator rồi
            chọn bài ưng ý. Đặt đơn với tư cách cá nhân chỉ cần tài khoản đã định danh, còn tài khoản doanh nghiệp cần nộp
            giấy tờ và chờ duyệt.
          </p>
        </div>
      )}

      {/* Cá nhân đặt đơn bằng Ca nạp: hiện khi chưa có tài khoản đặt đơn nào hoặc đã có tài khoản cá nhân. */}
      {showIndividualCard && (
        <IndividualOrdererCard
          account={individualAccount}
          topUpCa={topUpCa}
          onCreated={(a) => {
            setIndividualAccount(a);
            setShowIndividualCard(true);
          }}
        />
      )}

      <BusinessAccountSection purpose="collab" />

      {/* Nút tạo chiến dịch, brief, đơn nhận đề xuất và danh sách đơn: có tài khoản đặt đơn mới dùng được. */}
      {hasOrdererAccount && (
        <BrandCampaignSection bizAccounts={individualAccount ? [...bizAccounts, individualAccount] : bizAccounts} />
      )}
    </div>
  );
};

export default BrandOrdererHub;
